var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntralot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #f60;\n      }\n\n      .cls-3 {\n        mask: url(#mask);\n      }\n    "), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 26.58,
    y: 16.31,
    width: 26.84,
    height: 47.38,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_809_43325",
    "data-name": "mask0 809 43325"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53.42,16.31h-26.84v47.38h26.84V16.31Z"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 80,
    height: 80,
    rx: 10,
    ry: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.38,28.07c3.14,0,5.24,3.18,4.05,6.06l-12.26,29.57h-11.59l12.04-28.66c1.39-3.3,1.6-6.97-1.96-6.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.68,25.79c2.62,0,4.74-2.12,4.74-4.74s-2.12-4.74-4.74-4.74-4.74,2.12-4.74,4.74,2.12,4.74,4.74,4.74Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntralot);
export default __webpack_public_path__ + "static/media/intralot.0cad3e7ab3a0b7d88407bdc0a6449e30.svg";
export { ForwardRef as ReactComponent };